import { DocFlowWidgetStatus } from './DocFlow.constants'
import { MappingWidgetType } from './DocFlowMappingWidgets'

export function isDocFlowWidgetStatusCompleted(value) {
  return value === DocFlowWidgetStatus.Completed
}

export function isDocFlowWidgetStatusInProgress(value) {
  return value === DocFlowWidgetStatus.InProgress
}

export function isDocFlowWidgetStatusNotStarted(value) {
  return value === DocFlowWidgetStatus.NotStarted
}

export function isDocFlowWidgetStatusSkipped(value) {
  return value === DocFlowWidgetStatus.Skipped
}

export function isDocFlowActiveWidgetMappping(value) {
  return value === MappingWidgetType.Mapping
}

export function isDocFlowActiveWidgetSplitting(value) {
  return value === MappingWidgetType.Splitting
}

export function isDocFlowActiveWidgetResult(value) {
  return value === MappingWidgetType.Result
}

export function isDocFlowActiveWidgetType(value) {
  return value === MappingWidgetType.Type
}
